module.exports = __webpack_public_path__ + "static/media/whatsapp.0907e0da.svg";